import React, { useEffect } from 'react';
import { EVENTS_PORTAL_URL } from '@/lib/eventsPortal';

// The events section now lives on the unified portal — this route only redirects.
export default function EventiPage() {
  useEffect(() => {
    window.location.replace(EVENTS_PORTAL_URL);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="pv-eventi-redirect">
      <div className="text-center px-6">
        <p className="font-heading font-bold text-pv-ink text-xl">
          Ti stiamo portando al portale eventi Prime Vision…
        </p>
        <a
          href={EVENTS_PORTAL_URL}
          data-testid="pv-eventi-redirect-link"
          className="mt-4 inline-block text-pv-teal font-bold underline"
        >
          Vai a eventi.primevision.app
        </a>
      </div>
    </div>
  );
}
